function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "a",
  width: 23,
  height: 23,
  x: 1.5,
  y: 1.5,
  rx: 11.5
}), /*#__PURE__*/React.createElement("filter", {
  id: "b",
  width: "113%",
  height: "113%",
  x: "-6.5%",
  y: "-6.5%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: -3,
  in: "SourceAlpha",
  result: "shadowOffsetInner1"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "shadowOffsetInner1",
  in2: "SourceAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic",
  result: "shadowInnerInner1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowInnerInner1",
  result: "shadowMatrixInner1",
  values: "0 0 0 0 0.82745098 0 0 0 0 0.831372549 0 0 0 0 0.866666667 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 3,
  in: "SourceAlpha",
  result: "shadowOffsetInner2"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "shadowOffsetInner2",
  in2: "SourceAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic",
  result: "shadowInnerInner2"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowInnerInner2",
  result: "shadowMatrixInner2",
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixInner1"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixInner2"
}))));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#696979",
  fillRule: "nonzero",
  d: "M13 0c7.18 0 13 5.82 13 13s-5.82 13-13 13S0 20.18 0 13 5.82 0 13 0zm0 1.53C6.665 1.53 1.53 6.664 1.53 13c0 6.335 5.135 11.47 11.47 11.47 6.335 0 11.47-5.135 11.47-11.47 0-6.335-5.135-11.47-11.47-11.47z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  fill: "#F0F0F5",
  xlinkHref: "#a"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  filter: "url(#b)",
  xlinkHref: "#a"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#696979",
  d: "M18.946 15.31c.32.265.35.721.068 1.02-.212.225-.439.438-.68.636-3.19 2.633-8.058 2.348-10.874-.635a.69.69 0 0 1 .068-1.02.813.813 0 0 1 1.036.01l.055.054c2.25 2.385 6.143 2.613 8.694.508.192-.159.373-.329.543-.508a.81.81 0 0 1 1.09-.064zM8.733 8c.957 0 1.732.87 1.732 1.944 0 1.074-.775 1.945-1.732 1.945S7 11.019 7 9.944C7 8.871 7.776 8 8.733 8zm9.01 0c.956 0 1.732.87 1.732 1.944 0 1.074-.776 1.945-1.733 1.945-.957 0-1.732-.87-1.732-1.945 0-1.073.775-1.944 1.732-1.944z"
}));

var SvgSatisfeitoCinza = function SvgSatisfeitoCinza(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSatisfeitoCinza, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/satisfeito-cinza.30ae7b09.svg";
export { ForwardRef as ReactComponent };